import Swal from 'sweetalert2';
import Table from 'src/javascripts/components/Table';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import BuildApiUrl from 'src/javascripts/components/tables/url/BuildApiUrl';
import AddRowDataAttrs from 'src/javascripts/components/tables/helpers/AddRowDataAttrs';
import AddRowClickLinks from 'src/javascripts/components/tables/actions/AddRowClickLinks';
import GetCols from 'src/javascripts/components/tables/helpers/GetCols';
import NoDataMessage from 'src/javascripts/components/alerts/NoDataMessage';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk actions
import MergeBulk from 'src/javascripts/components/tables/bulk_actions/MergeBulk';

export default class AdminTableFixed extends Table {

  render() {

    // Set a spinner to indicate chart loading
    Spinner($(this.el).closest('.card'));
    if ($('#distributionContainer').length) {
      let distContainer = $('#distributionContainer')
      Spinner(distContainer);
      distContainer.find('.distribution-chart').css('opacity', '0.2');
    }

    // Set table id
    const tableId = this.el.attr('id');

    // Build url, use to get filtered data with server-side processing
    const dataUrl = BuildApiUrl(tableId);

    // Set additional data vars (used below in table creation)
    const cols = GetCols(this.el);

    // Set order col and dir
    let orderCol = $('#' + tableId).attr('data-order-col');
    if (typeof orderCol === 'undefined') {orderCol = 0};
    let orderDir = $('#' + tableId).attr('data-order-dir');
    if (typeof orderDir === 'undefined') {orderDir = 'asc'};

    // Optionally set secondary order col and dir
    let secondaryOrderCol = $('#' + tableId).attr('data-secondary-order-col');
    let secondaryOrderDir = $('#' + tableId).attr('data-secondary-order-dir');

    // Build order array
    let orderArr = [[parseInt(orderCol), orderDir]];
    if (typeof secondaryOrderCol !== 'undefined' && typeof secondaryOrderDir !== 'undefined') {
      orderArr.push([parseInt(secondaryOrderCol), secondaryOrderDir]);
    }

    // Left fixed
    let leftFixed = $('#' + tableId).attr('data-left-fixed');
    if (typeof leftFixed === 'undefined') {leftFixed = 1};

    // Length menu
    let lengthMenu;
    let lengthAll = $('#' + tableId).attr('data-length-all');
    if (typeof lengthAll === 'undefined') {
      lengthMenu = [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]];
    } else if (lengthAll === 'false') {
      lengthMenu = [[10, 25, 50, 100], [10, 25, 50, 100]];
    } else {
      lengthMenu = [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]];      
    }

    // Set whether to order or not
    let ordering = $('#' + tableId).attr('data-ordering');
    if (typeof ordering === 'undefined') {ordering = false;}

    // Auto width
    let autoWidth = $('#' + tableId).attr('data-auto-width');
    if (typeof autoWidth === 'undefined') {autoWidth = true;}

    // Set scroll-y
    let scrollY = $('#' + tableId).attr('data-scroll-y');
    if (typeof scrollY === 'undefined') {scrollY = 635;}

    // Length
    let length = 50;
    let lengthInd = $('#' + tableId).attr('data-length');
    if (typeof lengthInd !== 'undefined') {length = lengthInd;}

    // Render table
    // Most table options handled through data attrs on table element
    // https://datatables.net/manual/options
    // Responsive - details: false - don't show hidden details on small devices 
    // (https://datatables.net/reference/option/responsive)
    // Use 'retrieve' to avoid reinitialization error (https://datatables.net/manual/tech-notes/3)
    // orderCellsTop: required with adding searchable column in header row; without this the clickable ordering
    // gets lost behind search input
    const table = $('#' + tableId).DataTable({
      orderCellsTop: true,
      retrieve: true,
      serverSide: true,
      colReorder: true,
      scrollY: scrollY,
      scrollX: true,
      autoWidth: autoWidth,
      scrollCollapse: true,
      fixedColumns: {leftColumns: leftFixed, rightColumns: 1},
      paging: true,
      pageLength: length,
      lengthChange: true,
      lengthMenu: lengthMenu,
      info: true,
      ordering: ordering,
      order: orderArr,
      searching: true,
      ajax: dataUrl,
      dom: 'tlp',
      columns: cols,
      initComplete: function(settings, json) {
        let distribution = json.distribution;
        if (typeof distribution != 'undefined') {
          let distSize = distribution.length;
          function updateChart(values) {
            for (let i = 0; i < distSize; i++) {
              if ($('#distBar' + (i + 1)).length === 0) {continue;}
              document.getElementById('distBar' + (i + 1)).style.height = values[i][1] + '%';
              document.getElementById('distBarLabel' + (i + 1)).textContent = values[i][0];
              let bucketLabel = values[i][2];
              if (typeof bucketLabel !== 'undefined') {
                document.getElementById('distBucketLabel' + (i + 1)).textContent = bucketLabel;
              }
            }
            // Remove spinner and restore opacity
            if ($('#distributionContainer').length) {
              let distContainer = $('#distributionContainer');
              distContainer.find('.spinner-container').remove();
              distContainer.find('.distribution-chart').css('opacity', '1');
            }
          }
          updateChart(distribution);
        }

      }, 
      createdRow(row, data, dataIndex) {

        // Add data attrs to row
        AddRowDataAttrs(row, data);


      },
      drawCallback: function( settings ) {

        // Remove spinner after table has drawn
        $('#' + tableId).closest('.card').find('.spinner-container').remove();
        $('#' + tableId).closest('.card-body').css('opacity', 1);

        // Number results
        let numberResults = settings.json.recordsFiltered;
        numberResults = Math.abs(numberResults).toLocaleString("en", {minimumFracctionDigits: 0, maximumFractionDigits: 0});
        $('#numberResults').empty().append("(" + numberResults + ")");

        // Percent production ready
        let percentProductionReady = settings.json.percentProductionReady;
        if (typeof percentProductionReady !== "undefined") {
          $('#percentProductionReady').empty().append(percentProductionReady);
        }

        // Scroll to top of the table on page change
        let scrollBody = this.api().table().container().querySelector('.dataTables_scrollBody');
        if (scrollBody) {
          scrollBody.scrollTop = 0;
        } else {
          // Fallback: scroll parent card-body or wrapper
          let tableWrapper = $('#' + tableId).closest('.card-body')[0] || document.querySelector('.admin-table-wrapper');
          if (tableWrapper) tableWrapper.scrollTop = 0;
        }

        // Re-init tooltips
        $('[data-toggle=tooltip]').tooltip();

        // Enable/disable buttons
        let maxExport = $('#' + tableId).attr('data-max-export');
        if (typeof maxExport !== 'undefined') {
          let disabledExport = $('.disabled-export');
          let enabledExport = $('.enabled-export');
          if (settings.json.recordsFiltered > parseFloat(maxExport)) {
            disabledExport.removeClass('d-none');
            enabledExport.addClass('d-none');
          } else {
            disabledExport.addClass('d-none');
            enabledExport.removeClass('d-none');            
          }
        }

        // Bulk actions
        MergeBulk(tableId);

        // If mark complete is present (for reviews)
        $('.update-metric-score-status').click(function() {
          $('#' + tableId).css('opacity', 0.25);
          let row = $(this).closest('tr');
          let companyId = row.attr('data-company-id');
          let metricScoreId = $(this).attr('data-metric-score-id');
          let status = $(this).attr('data-status');
          let params = {};
          params['company_metric_score'] = {};
          params['company_metric_score']['status'] = status;
          params['company_metric_score']['company_id'] = companyId;
          params['company_metric_score']['metric_score_id'] = metricScoreId;
          let url = "/companies/" + companyId + "/metric_scores/" + metricScoreId + ".json?" + $.param(params);
          $.ajax({
            type: 'PATCH',
            dataType: 'application/json',
            url: url,
            complete(result) {
              let responseText = JSON.parse(result.responseText);
              let metricScoreId = responseText.metric_score_id;
              let scoreStatus = responseText.score_status;
              let row = $('#' + tableId).find("tr[data-record-id=" + metricScoreId + "]");
              let ratingClass;
              let ratingText;
              if (scoreStatus === "production_ready") {
                ratingClass = "text-a-rating";
                ratingText = "Production ready";
              } else if (scoreStatus === "final_review_completed") {
                ratingClass = "text-b-rating";
                ratingText = "Final review completed";
              } else if (scoreStatus === "analyst_completed") {
                ratingClass = "text-c-rating";
                ratingText = "Analyst completed";
              } else if (scoreStatus === "not_relevant") {
                ratingClass = "text-no-rating";
                ratingText = "Not relevant";
              } else if (scoreStatus === "needs_ethos_review") {
                ratingClass = "text-f-rating";
                ratingText = "Needs Ethos review";
              } else {
                ratingClass = "text-f-rating";
                ratingText = "In queue";
              }
              row.find('.review-status').replaceWith("<span class=\'font-weight-bold review-status " + ratingClass + "\'>" + ratingText + "</span>");
              $('#' + tableId).css('opacity', 1);
              ToastCustom('Updated', 'Status updated', 5000);
            },
          });
        })

        // If mark complete is present (for reviews)
        $('.update-screen-status').click(function() {
          $('#' + tableId).css('opacity', 0.25);
          let row = $(this).closest('tr');
          let companyId = row.attr('data-company-id');
          let screenId = $(this).attr('data-company-screen-id');
          let status = $(this).attr('data-status');
          let params = {};
          params['company_screen'] = {};
          params['company_screen']['status'] = status;
          params['company_screen']['company_id'] = companyId;
          let url = "/companies/" + companyId + "/screens/" + screenId + ".json?" + $.param(params);
          $.ajax({
            type: 'PATCH',
            dataType: 'application/json',
            url: url,
            complete(result) {
              // Reload table, maintaining scroll and paging 
              let table = $('#' + tableId).DataTable();
              let scrollBody = table ? table.table().container().querySelector('.dataTables_scrollBody') : null;
              let scrollTop = scrollBody ? scrollBody.scrollTop : 0;
              table.ajax.reload(function() {
                if (scrollBody) { scrollBody.scrollTop = scrollTop; }
              }, false);
              $('#' + tableId).css('opacity', 1);
              ToastCustom('Updated', 'Status updated', 5000);
              // Hide tooltips
              $('[data-toggle=tooltip]').tooltip('hide');
            },

          });

        })


      }

    });

    return 'rendered';

  }

  setUp(tableId) {

    // Set table
    let oTable = $('#' + tableId).DataTable();

    // Set searchable function for table
    $('#search_' + tableId).keyup(function(){
      oTable.search( $(this).val() ).draw();
    });

    // On click of row
    $('#' + tableId).on('click', 'tbody > tr > td:not(:first-child):not(:last-child)', function() { 
      let url = $(this).closest('tr').attr('data-view-url');
      if (typeof url !== 'undefined') {
        return Turbo.visit(url);
      }
    });

    return 'setup';

  }


};
